import React, { useState, useEffect } from 'react';
import { createTopic, updateTopic } from '../../api/api';
import { Topic } from '../../types';

interface Props {
  packageId: string;
  initialData?: Topic | null;
  onSuccess: (newTopic: Topic) => void;
}

const TopicForm: React.FC<Props> = ({ packageId, initialData, onSuccess }) => {
  const isEditing = !!initialData;
  
  // State
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Effect
  useEffect(() => {
    if (isEditing && initialData) {
      setName(initialData.name);
    } else {
      setName('');
    }
  }, [initialData, isEditing]);

  // Handler
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const topicData: Omit<Topic, 'id' | 'vocabularies'> = {
      name,
      packageId,
      image: initialData?.image || '',
    };

    try {
      if (isEditing && initialData) {
        await updateTopic(initialData.id, topicData);
        onSuccess(initialData);
      } else {
        const newTopic = await createTopic(topicData);
        onSuccess(newTopic);
      }
    } catch (err) {
      setError('Failed to save topic.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="creation-form">
      <input type="text" placeholder="Topic Name" value={name} onChange={(e) => setName(e.target.value)} required disabled={isLoading} />
      {error && <p className="error-message">{error}</p>}
      <button type="submit" className="btn" disabled={isLoading}>
        {isLoading ? 'Saving...' : (isEditing ? 'Save Changes' : 'Create Topic')}
      </button>
    </form>
  );
};

export default TopicForm;